<template>
  <div>
    <div class="disbursement__single outer-container">
      <div class="panel">
        <div class="panel__header">
          <disburse-options></disburse-options>
        </div>
        <div class="
            panel__content panel__content--grey panel__content--heavy-padded
          ">
          <!--single transfer-->
          <form action class="form disburse-form disburse-form__single">
            <div class="form__item">
              <label for="disburseSource" class="form__label--span form--left">Send
                <span>from</span>
              </label>
              <div class="select form--right">
                <select name="disburse-source" id="disburseSource" class="select__input" v-model="selectedBalance"
                  v-validate="'required'" @change="selectedSource(selectedBalance)">
                  <option value disabled>
                    Select wallet balance to disburse from
                  </option>
                  <option v-for="option in walletList" v-bind:value="option">
                    {{ option.name.toUpperCase() }} -
                    {{ option.currencyCode }}
                    {{ option.currencyBalance | numeralize("0,0.00") }}
                  </option>
                </select>
                <div class="select__icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="6" height="10" viewBox="0 0 6 10">
                    <path fill-rule="evenodd" d="M6.03 3.03L3.025.025.02 3.03h6.01zM5.88 7.071L2.975 9.975.07 7.07H5.88z">
                    </path>
                  </svg>
                </div>
              </div>
            </div>
            <!--if error exists-->
            <transition name="slide-fade">
              <div class="form__input--error--text" v-if="errors.has('disburse-source')">
                <p>{{ errors.first("disburse-source") }}</p>
              </div>
            </transition>

            <!--disburse amount-->
            <div class="form__item">
              <label for="disburseAmount" class="form__label--span form--left">Payment
                <span>amount</span>
              </label>
              <div class="form--right input-conjoined">
                <input type="text" class="form__input" :disabled="true" v-model="payoutObj.wallet.currency" readonly />
                <input type="number" name="disburse-amount" class="form__input" placeholder id="disburseAmount"
                  v-model="payoutObj.amount" v-validate="'required|decimal:4'" />
              </div>
            </div>
            <!--if error exists-->
            <transition name="slide-fade">
              <div class="form__input--error--text" v-if="errors.has('disburse-amount')">
                <p>{{ errors.first("disburse-amount") }}</p>
              </div>
            </transition>

            <!--payment beneficiary type-->
            <div class="form__item">
              <label class="form__label--span form--left">Send money
                <span>to</span>
              </label>
              <!-- <div class="form--right form__radios">
                <div class="radio__item radio-container radio__item__flex">
                  <input
                    type="radio"
                    class="radio__item__input"
                    value="saved_beneficiary"
                    name="beneficiary-type"
                    id="disburseBeneficiarySaved"
                    v-model="destinationOption"
                    placeholder
                  >
                  <label for="disburseBeneficiarySaved" class="radio__item__label">Saved Recipient</label>
                </div>
                <div class="radio__item radio-container radio__item__flex">
                  <input
                    type="radio"
                    class="radio__item__input"
                    value="new_account"
                    name="beneficiary-type"
                    id="disburseBeneficiaryNew"
                    v-model="destinationOption"
                    placeholder
                  >
                  <label for="disburseBeneficiaryNew" class="radio__item__label">New Account</label>
                </div>
              </div> -->
              <div class="select recipient-list form--right">
                <!-- <v-select
                  label="accountName"
                  :options="filteredBeneficiary"
                  name="beneficiary"
                  class="select__input"
                  v-model="beneficiaryAccountDetail"
                  v-validate="'required'"
                  @change="selectedBenf(beneficiaryAccountDetail)"
                ></v-select> -->

                <select name="beneficiary-source" id="beneficiarySource" class="select__input"
                  v-model="beneficiaryAccountDetail" v-validate="'required'"
                  @change="selectedBenf(beneficiaryAccountDetail)">
                  <!-- <option value disabled>Select Benefciary / Type</option> -->
                  <option v-for="option in filteredBeneficiary" v-bind:value="option">
                    {{ option.accountName }}
                  </option>
                </select>
              </div>
              <transition name="slide-fade">
                <div class="form__input--error--text" v-if="errors.has('beneficiary')">
                  <p>{{ errors.first("beneficiary") }}</p>
                </div>
              </transition>
            </div>

            <!--if saved beneficiary is chosen-->
            <!-- <div v-if="beneficiaryAccountDetail.bankCode === 'saved_beneficiary'">
              <div class="form__item form__item--not-last">
                <label class="form__label--span form--left">Select
                  <span>beneficiary</span>
                </label>

              </div>
            </div> -->

            <!--If new account is chosen choose bank-->
            <div v-if="beneficiaryAccountDetail.id < 1">
              <div class="form__item">
                <label for="bank" class="form__label--span form--left">Select
                  <span>Bank</span>
                </label>
                <div class="select form--right">
                  <select name="banks" id="bank" class="select__input" v-model="payoutObj.accountBankCode" v-validate="beneficiaryAccountDetail.id === 0 ? 'required' : ''
                    " @change="selectedBank(payoutObj.accountBankCode)">
                    <option value disabled>Select Bank</option>
                    <option v-for="bank in filteredBankList" v-bind:value="bank.value">
                      {{ bank.name }}
                    </option>
                  </select>
                  <div class="select__icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="6" height="10" viewBox="0 0 6 10">
                      <path fill-rule="evenodd"
                        d="M6.03 3.03L3.025.025.02 3.03h6.01zM5.88 7.071L2.975 9.975.07 7.07H5.88z"></path>
                    </svg>
                  </div>
                </div>
              </div>
              <!--if error exists-->
              <transition name="slide-fade">
                <div class="form__input--error--text" v-if="errors.has('banks')">
                  <p>{{ errors.first("banks") }}</p>
                </div>
              </transition>

              <transition name="slide-fade">
                <div class="form__item" v-if="branchRequired">
                  <label for="bank" class="form__label--span form--left">Select
                    <span>Branch</span>
                  </label>
                  <div class="select form--right">
                    <select name="branch" id="branch" class="select__input" v-model="payoutObj.branchCode"
                      v-validate="branchRequired ? 'required' : ''">
                      <option value disabled>Select Branch</option>
                      <option v-for="(branch, code) in branchListObj" v-bind:value="code" v-bind:key="code">
                        {{ branch }}
                      </option>
                    </select>
                    <div class="select__icon">
                      <svg xmlns="http://www.w3.org/2000/svg" width="6" height="10" viewBox="0 0 6 10">
                        <path fill-rule="evenodd"
                          d="M6.03 3.03L3.025.025.02 3.03h6.01zM5.88 7.071L2.975 9.975.07 7.07H5.88z"></path>
                      </svg>
                    </div>
                  </div>
                </div>
              </transition>
              <!--if error exists-->
              <transition name="slide-fade">
                <div class="form__input--error--text" v-if="errors.has('branch')">
                  <p>{{ errors.first("branch") }}</p>
                </div>
              </transition>
            </div>

            <div v-if="beneficiaryAccountDetail.id === 0">
              <div class="form__item">
                <label class="form__label--span form--left">Account
                  <span>number</span>
                </label>
                <div class="recipient-list form--right">
                  <input id="accountNumber" name="Recipient" type="text" class="form__input" placeholder="0123456789"
                    v-model="payoutObj.accountNumber" v-validate="destinationOption === 'new_account' ? 'required' : ''
                      " />
                </div>
                <span style="position: absolute; right: 30px"><small>{{ accountNameInfo }}</small></span>
              </div>
              <!--if account name error exists-->
              <transition name="slide-fade">
                <div class="form__input--error--text" v-if="accountNameError">
                  <p>{{ accountNameError }}</p>
                </div>
              </transition>
              <!--if error exists-->
              <transition name="slide-fade">
                <div class="form__input--error--text" v-if="errors.has('Recipient')">
                  <p>{{ errors.first("Recipient") }}</p>
                </div>
              </transition>

              <div v-if="requireAccountName" class="form__item">
                <label for="accountName" class="form__label--span form--left">Account
                  <span>name</span>
                </label>
                <div class="recipient-list form--right">
                  <input id="accountName" type="text" name="accountName" class="form__input" placeholder="Account Name"
                    v-model="payoutObj.accountName" v-validate="'required'"  />
                </div>
              </div>
              <div v-if="requireAccountName" class="form--right">
                <transition name="slide-fade">
                  <div class="form__input--error--text" v-if="errors.has('accountName')">
                    <p>{{ errors.first("accountName") }}</p>
                  </div>
                </transition>
              </div>

              <div v-if="requiresafaricom" class="form__item">

                <label for="recipientphone" class="form__label--span form--left">Recipient
                  <span>Phone</span>
                </label>
                <div class="recipient-list form--right">
                  <input id="recipientphone" name="recipientphone" type="phone" class="form__input"
                    placeholder="Recipient Phone" v-validate="'required'" maxlength="13"
                    v-model="payoutObj.custom_recipientphone" />
                </div>
              </div>
              <transition name="slide-fade">
                <div class="form__input--error--text" v-if="errors.has('recipientphone')">
                  <p>{{ errors.first("recipientphone") }}</p>
                </div>
              </transition>
            </div>

            <div v-if="requireUSUKbeneficiary && beneficiaryAccountDetail.id === 0">
              <div class="form__item">
                <label for="accountName" class="form__label--span form--left">Swift
                  <span>Code</span>
                </label>
                <div class="recipient-list form--right">
                  <input id="swiftcode" type="text" class="form__input" placeholder="Swift Code"
                    v-model="payoutObj.custom_swiftcode" />
                </div>
              </div>
            </div>

            <div v-if="requireUSUKbeneficiary && beneficiaryAccountDetail.id < 1">
              <br />
              <center style="color: #aaa">Sender Details</center>
              <br />

              <div class="form__item">
                <label for="accountName" class="form__label--span form--left">Sender
                  <span>Name</span>
                </label>
                <div class="recipient-list form--right">
                  <input id="senderName" type="text" class="form__input" placeholder="Sender Full Name"
                    v-model="payoutObj.custom_sendername" />
                </div>
              </div>
              <div class="form__item">
                <label for="accountName" class="form__label--span form--left">Sender
                  <span>Contact</span>
                </label>
                <div class="recipient-list form--right">
                  <input id="custom_senderemail" name="custom_senderemail" type="email" class="form__input"
                    placeholder="Sender Email" v-model="payoutObj.custom_senderemail" v-validate="'required'" />
                </div>
                <div class="form--right">
                <transition name="slide-fade">
                  <div class="form__input--error--text" v-if="errors.has('custom_senderemail')">
                    <p>{{ errors.first("custom_senderemail") }}</p>
                  </div>
                </transition>
              </div>
                &nbsp;&nbsp;
                <div class="recipient-list form--right">
                  <input id="custom_senderphone" name="custom_senderphone" type="phone" class="form__input"
                    placeholder="Sender Phone" v-validate="'required'" v-model="payoutObj.custom_senderphone"
                    maxlength="13" />
                </div>
              </div>
              <div class="form--right">
                <transition name="slide-fade">
                  <div class="form__input--error--text" v-if="errors.has('custom_senderphone')">
                    <p>{{ errors.first("custom_senderphone") }}</p>
                  </div>
                </transition>
              </div>
              <div class="form__item">
                <label for="accountName" class="form__label--span form--left">Sender
                  <span>Address</span>
                </label>
                <div class="recipient-list form--right">
                  <input id="senderAddress" type="text" class="form__input" placeholder="Sender Address"
                    v-model="payoutObj.custom_senderaddress" />
                </div>
              </div>
              <div class="form__item">
                <label for="accountName" class="form__label--span form--left">Sender
                  <span>Location</span>
                </label>
                <div class="recipient-list form--right">
                  <select name="countries" id="senderLocation" class="select__input"
                    v-model="payoutObj.custom_senderlocation">
                    <option value disabled>Select Country</option>
                    <option v-for="(country, index) in countriesList" :key="index" v-bind:value="country.code">
                      {{ country.name }}
                    </option>
                  </select>
                </div>
              </div>
              <!-- <div class="form__item">
                <label for="accountName" class="form__label--span form--left">Routing
                  <span>Number</span>
                </label>
                <div
                  class="recipient-list form--right">
                <input
                    id="recipientAddress"
                    type="text"
                    class="form__input"
                    placeholder="Routing Number"
                    v-model="payoutObj.custom_routingnumber"
                  >
                </div>
              </div> -->

              <!-- <div class="form__item">
                <label for="accountName" class="form__label--span form--left">Postal
                  <span>Code</span>
                </label>
                <div
                  class="recipient-list form--right">
                <input
                    id="recipientAddress"
                    type="text"
                    class="form__input"
                    placeholder="Postal Code"
                    v-model="payoutObj.custom_postalcode"
                  >
                </div>
              </div> -->

              <!-- <div class="form__item">
                <label for="accountName" class="form__label--span form--left">Street
                  <span>Number</span>
                </label>
                <div
                  class="recipient-list form--right">
                <input
                    id="recipientAddress"
                    type="text"
                    class="form__input"
                    placeholder="Street Number"
                    v-model="payoutObj.custom_streetnumber"
                  >
                </div>
                &nbsp;&nbsp;
                <div
                  class="recipient-list form--right">
                <input
                    id="recipientAddress"
                    type="text"
                    class="form__input"
                    placeholder="Street Name"
                    v-model="payoutObj.custom_streetname"
                  >
                </div>
              </div> -->

              <br />
              <center style="color: #aaa">Beneficiary Details</center>
              <br />

              <div class="form__item">
                <label for="accountName" class="form__label--span form--left">Recipient
                  <span>Name</span>
                </label>
                <div class="recipient-list form--right">
                  <input id="custom_recipientname" name="custom_recipientname" type="text" class="form__input"
                    placeholder="Recipient Full Name" v-model="payoutObj.custom_recipientname" />
                </div>
              </div>
              <div class="form__item">
                <label for="accountName" class="form__label--span form--left">Recipient
                  <span>Contact</span>
                </label>
                <div class="recipient-list form--right">
                  <input id="custom_recipientemail" name="custom_recipientemail" type="email" class="form__input"
                    placeholder="Recipient Email" v-model="payoutObj.custom_recipientemail" v-validate="'required'" />
                </div>
                <div class="form--right">
                  <transition name="slide-fade">
                    <div class="form__input--error--text" v-if="errors.has('custom_recipientemail')">
                      <p>{{ errors.first("custom_recipientemail") }}</p>
                    </div>
                  </transition>
                </div>
                &nbsp;&nbsp;
                <div class="recipient-list form--right">
                  <input id="custom_recipientphone" name="custom_recipientphone" type="phone" class="form__input"
                    placeholder="Recipient Phone 234xxx" v-validate="'required'"
                    v-model="payoutObj.custom_recipientphone" />
                </div>
              </div>
              <div class="form--right">
                <transition name="slide-fade">
                  <div class="form__input--error--text" v-if="errors.has('custom_recipientphone')">
                    <p>{{ errors.first("custom_recipientphone") }}</p>
                  </div>
                </transition>
              </div>
              <div v-if="requireRecipientAddress" class="form__item">
                <label for="accountName" class="form__label--span form--left">Recipient
                  <span>Address</span>
                </label>
                <div class="recipient-list form--right">
                  <input id="recipientAddress" type="text" class="form__input" placeholder="Recipient Address"
                    v-model="payoutObj.recipientAddress" />
                </div>
              </div>

              <div v-if="beneficiaryAccountDetail.type === 'pickup'">
                <br />
                <center style="color: #aaa">Secure Info</center>
                <br />
              </div>

              <div class="form__item">
                <label for="accountName" class="form__label--span form--left">Recipient
                  <span>Phone</span>
                </label>
                <div class="recipient-list form--right">
                  <input id="recipientphone" name="recipientphone" type="phone" class="form__input"
                    placeholder="recipient Phone" v-validate="'required'" v-model="payoutObj.custom_recipientphone" />
                </div>
              </div>
              <transition name="slide-fade">
                <div class="form__input--error--text" v-if="errors.has('recipientphone')">
                  <p>{{ errors.first("recipientphone") }}</p>
                </div>
              </transition>

              <div v-if="beneficiaryAccountDetail.type === 'pickup'" class="form__item">
                <label for="accountName" class="form__label--span form--left">Secure
                  <span>Question</span>
                </label>
                <div class="recipient-list form--right">
                  <input id="recipientAddress" type="text" class="form__input" placeholder="Verify Question"
                    v-model="payoutObj.custom_question" />
                </div>

                <!-- <label for="accountName" class="form__label--span form--left">Verify
                  <span>Answer</span>
                </label> -->
                <div class="recipient-list form--right">
                  <input id="recipientAddress" type="text" class="form__input" placeholder="Verify Answer"
                    v-model="payoutObj.custom_answer" />
                </div>
              </div>

              <br />
              <br />
            </div>
            <div v-else-if="(requiresafaricom || benefNameRequired) &&
              beneficiaryAccountDetail.id === 0
              ">
              <div v-if="benefNameRequired">
                <br />
                <center style="color: #aaa">Beneficiary Details</center>
                <br />

                <div class="form__item">
                  <label for="accountName" class="form__label--span form--left">Recipient
                    <span>Name</span>
                  </label>
                  <div class="recipient-list form--right">
                    <input id="recipientName" name="recipientName" type="text" class="form__input" v-validate="'required'"
                      placeholder="Recipient Full Name" v-model="payoutObj.custom_recipientname" />
                  </div>
                </div>
                <transition name="slide-fade">
                  <div class="form__input--error--text" v-if="errors.has('recipientName')">
                    <p>
                      {{ errors.first("recipientName") }}
                    </p>
                  </div>
                </transition>
              </div>

              <br />
              <center style="color: #aaa">Sender Details</center>
              <br />

              <div class="form__item">
                <label for="accountName" class="form__label--span form--left">Sender
                  <span>Name</span>
                </label>
                <div class="recipient-list form--right">
                  <input id="senderName" name="senderName" type="text" class="form__input" placeholder="Sender Full Name"
                    v-validate="'required'" v-model="payoutObj.custom_sendername" />
                </div>
              </div>
              <transition name="slide-fade">
                <div class="form__input--error--text" v-if="errors.has('senderName')">
                  <p>{{ errors.first("senderName") }}</p>
                </div>
              </transition>

              <div class="form__item">
                <label for="senderphone" class="form__label--span form--left">Sender
                  <span>Phone</span>
                </label>
                <div class="recipient-list form--right">
                  <input id="senderphone" name="senderphone" type="phone" class="form__input" placeholder="Sender Phone"
                    v-validate="'required'" v-model="payoutObj.custom_senderphone" />
                </div>
              </div>
              <transition name="slide-fade">
                <div class="form__input--error--text" v-if="errors.has('senderphone')">
                  <p>{{ errors.first("senderphone") }}</p>
                </div>
              </transition>

              <div class="form__item">
                <label for="country" class="form__label--span form--left">Sender
                  <span>Country</span>
                </label>
                <div class="select form--right">
                  <select name="country" id="country" class="select__input" v-model="payoutObj.custom_sendercountry"
                    v-validate="'required'">
                    <option value disabled>Select Country</option>
                    <option v-for="country in currencyList" v-bind:value="country.value">
                      {{ country.name }}
                    </option>
                  </select>
                  <div class="select__icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="6" height="10" viewBox="0 0 6 10">
                      <path fill-rule="evenodd"
                        d="M6.03 3.03L3.025.025.02 3.03h6.01zM5.88 7.071L2.975 9.975.07 7.07H5.88z"></path>
                    </svg>
                  </div>
                </div>
              </div>
              <transition name="slide-fade">
                <div class="form__input--error--text" v-if="errors.has('country')">
                  <p>{{ errors.first("country") }}</p>
                </div>
              </transition>

              <div v-if="requiresafaricom">
                <div class="form__item">
                  <label for="nationality" class="form__label--span form--left">Sender
                    <span>Nationality</span>
                  </label>
                  <div class="select form--right">
                    <select name="nationality" id="nationality" class="select__input"
                      v-model="payoutObj.custom_sendernationality" v-validate="'required'">
                      <option value disabled>Select Nationality</option>
                      <option v-for="nationality in currencyList" v-bind:value="nationality.value">
                        {{ nationality.name }}
                      </option>
                    </select>
                    <div class="select__icon">
                      <svg xmlns="http://www.w3.org/2000/svg" width="6" height="10" viewBox="0 0 6 10">
                        <path fill-rule="evenodd"
                          d="M6.03 3.03L3.025.025.02 3.03h6.01zM5.88 7.071L2.975 9.975.07 7.07H5.88z"></path>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>

              <transition name="slide-fade">
                <div class="form__input--error--text" v-if="errors.has('nationality')">
                  <p>{{ errors.first("nationality") }}</p>
                </div>
              </transition>

              <div v-if="requiresafaricom">
                <div class="form__item">
                  <label for="senderaddress" class="form__label--span form--left">Sender
                    <span>Address</span>
                  </label>
                  <div class="recipient-list form--right">
                    <input id="senderaddress" name="senderaddress" type="text" class="form__input"
                      placeholder="Sender Address" v-validate="'required'" maxlength="128"
                      v-model="payoutObj.custom_senderaddress" />
                  </div>
                </div>
              </div>
              <transition name="slide-fade">
                <div class="form__input--error--text" v-if="errors.has('senderaddress')">
                  <p>{{ errors.first("senderaddress") }}</p>
                </div>
              </transition>


              <div v-if="requiresafaricom">
                <div class="form__item">
                  <label for="idtype" class="form__label--span form--left">Sender
                    <span>ID Type</span>
                  </label>
                  <div class="select form--right">
                    <select name="idtype" id="idtype" class="select__input" v-model="payoutObj.custom_senderidtype"
                      v-validate="'required'">
                      <option value disabled>Select ID Type</option>
                      <option value="passport">
                        Passport
                      </option>
                    </select>
                    <div class="select__icon">
                      <svg xmlns="http://www.w3.org/2000/svg" width="6" height="10" viewBox="0 0 6 10">
                        <path fill-rule="evenodd"
                          d="M6.03 3.03L3.025.025.02 3.03h6.01zM5.88 7.071L2.975 9.975.07 7.07H5.88z"></path>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>

              <transition name="slide-fade">
                <div class="form__input--error--text" v-if="errors.has('idtype')">
                  <p>{{ errors.first("idtype") }}</p>
                </div>
              </transition>

              <div v-if="requiresafaricom">
                <div class="form__item">
                  <label for="senderidnumber" class="form__label--span form--left">Sender
                    <span>ID Number</span>
                  </label>
                  <div class="recipient-list form--right">
                    <input id="senderidnumber" name="senderidnumber" type="text" class="form__input"
                      placeholder="Sender ID Number" v-validate="'required'" v-model="payoutObj.custom_senderidnumber" />
                  </div>
                </div>
              </div>
              <transition name="slide-fade">
                <div class="form__input--error--text" v-if="errors.has('senderidnumber')">
                  <p>{{ errors.first("senderidnumber") }}</p>
                </div>
              </transition>

              <div v-if="requiresafaricom">
                <div class="form__item">
                  <label for="senderdob" class="form__label--span form--left">Sender
                    <span>DOB</span>
                  </label>
                  <div class="recipient-list form--right">
                    <datepicker
                      :inputClass="'form__input input'"
                      v-validate="'required'"
                      name="senderdob"
                      v-model="payoutObj.custom_senderdob"
                      :placeholder="'Date of Birth'"
                      @selected="formatDOB"
                    >
                    </datepicker>
                  </div>
                </div>
                <transition name="slide-fade">
                  <div class="form__input--error--text" v-if="errors.has('senderdob')">
                    <p>{{ errors.first('senderdob') }}</p>
                  </div>
                </transition>
              </div>
              <div v-if="requiresafaricom">
                <div class="form__item">
                  <label for="senderoccupation" class="form__label--span form--left">Sender
                    <span>Occupation</span>
                  </label>
                  <div class="recipient-list form--right">
                    <input id="senderoccupation" name="senderoccupation" type="text" class="form__input"
                      placeholder="Sender Occupation" v-validate="'required'"
                      v-model="payoutObj.custom_senderoccupation" />
                  </div>
                </div>
              </div>
              <transition name="slide-fade">
                <div class="form__input--error--text" v-if="errors.has('senderoccupation')">
                  <p>{{ errors.first("senderoccupation") }}</p>
                </div>
              </transition>

              <div v-if="requiresafaricom">
                <div class="form__item">
                  <label for="sendersourceoffunds" class="form__label--span form--left">Sender
                    <span>Fund Source</span>
                  </label>
                  <div class="recipient-list form--right">
                    <input id="sendersourceoffunds" name="sendersourceoffunds" type="text" class="form__input"
                      placeholder="Sender Source Of Funds" v-validate="'required'"
                      v-model="payoutObj.custom_sendersourceoffunds" />
                  </div>
                </div>
              </div>
              <transition name="slide-fade">
                <div class="form__input--error--text" v-if="errors.has('sendersourceoffunds')">
                  <p>{{ errors.first("sendersourceoffunds") }}</p>
                </div>
              </transition>

              <br />
              <br />
            </div>

            <!--payment reference-->
            <div class="form__item">
              <label for="disburseReference" class="form__label--span form--left">Payment
                <span>description</span>
              </label>
              <div class="amount-input form--right">
                <input type="text" class="form__input" id="disburseReference" name="disburseReference"
                  placeholder="Transfer description" v-model="payoutObj.narration" />
              </div>
            </div>

            <div class="form__item">
              <label for="walletPassword" class="form__label--span form--left">Wallet
                <span>password</span>
              </label>
              <div class="recipient-list form--right">
                <input id="walletPassword" name="wpassword" type="password" autocomplete="new-password"
                  class="form__input" placeholder v-model="payoutObj.wallet.password" v-validate="'required'" />
              </div>
            </div>
            <!--if error exists-->
            <transition name="slide-fade">
              <div class="form__input--error--text" v-if="errors.has('wpassword')">
                <p>{{ errors.first("wpassword") }}</p>
              </div>
            </transition>

            <div class="form__item disburse-form__submit xxschedule-payment" v-if="enableActions">
              <a class="btn btn--primary btn--block" :disabled="errors.any()" @click="verifyFields()">SEND NOW</a>
              <p>{{ momentToday }} </p>
              <!--schedule payment-->
              <!-- <a
                class="btn btn--default btn--schedule"
                title="schedule payment"
                data-toggle="modal"
                data-target="#schedulePaymentModal"
              >
                <span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    version="1.1"
                    id="Capa_1"
                    x="0px"
                    y="0px"
                    width="512px"
                    height="512px"
                    viewBox="0 0 612 612"
                    style="enable-background:new 0 0 612 612;"
                    xml:space="preserve"
                    class="icon--sm"
                  >
                    <g>
                      <g>
                        <g>
                          <path
                            d="M587.572,186.881c-32.266-75.225-87.096-129.934-162.949-162.285C386.711,8.427,346.992,0.168,305.497,0.168    c-41.488,0-80.914,8.181-118.784,24.428C111.488,56.861,56.415,111.535,24.092,186.881C7.895,224.629,0,264.176,0,305.664    c0,41.496,7.895,81.371,24.092,119.127c32.323,75.346,87.403,130.348,162.621,162.621c37.877,16.247,77.295,24.42,118.784,24.42    c41.489,0,81.214-8.259,119.12-24.42c75.853-32.352,130.683-87.403,162.956-162.621C603.819,386.914,612,347.16,612,305.664    C612,264.176,603.826,224.757,587.572,186.881z M538.724,440.853c-24.021,41.195-56.929,73.876-98.375,98.039    c-41.195,24.021-86.332,36.135-134.845,36.135c-36.47,0-71.27-7.024-104.4-21.415c-33.129-14.384-61.733-33.294-85.661-57.215    c-23.928-23.928-42.973-52.811-57.214-85.997c-14.199-33.065-21.08-68.258-21.08-104.735c0-48.52,11.921-93.428,35.807-134.509    c23.971-41.231,56.886-73.947,98.039-98.04c41.146-24.092,85.99-36.142,134.502-36.142c48.52,0,93.649,12.121,134.845,36.142    c41.446,24.164,74.283,56.879,98.375,98.039c24.092,41.153,36.135,85.99,36.135,134.509    C574.852,354.185,562.888,399.399,538.724,440.853z"
                            data-original="#000000"
                            class="active-path"
                            data-old_color="#576ae6"
                            fill="#576ae6"
                          ></path>
                          <path
                            d="M324.906,302.988V129.659c0-10.372-9.037-18.738-19.41-18.738c-9.701,0-18.403,8.366-18.403,18.738v176.005    c0,0.336,0.671,1.678,0.671,2.678c-0.671,6.024,1.007,11.043,5.019,15.062l100.053,100.046c6.695,6.695,19.073,6.695,25.763,0    c7.694-7.695,7.188-18.86,0-26.099L324.906,302.988z"
                            data-original="#000000"
                            class="active-path"
                            data-old_color="#576ae6"
                            fill="#576ae6"
                          ></path>
                        </g>
                      </g>
                    </g>
                  </svg>
                </span>
              </a> -->
            </div>
          </form>
        </div>
      </div>
    </div>
    <!--modals-->
    <div class="modal fade" id="confirmPaymentModal" tabindex="-1" role="dialog" aria-labelledby="confirmPaymentModal">
      <!-- Modal Dialog -->
      <div class="modal__dialog modal__dialog--xlg" role="document">
        <!-- Modal content -->
        <div class="modal__content">
          <div class="modal__header">
            <div class="modal__title">
              Payment
              <span>Confirmation</span>
            </div>
            <!-- Modal close button -->
            <button type="button" class="close btn btn--default btn--sm" data-dismiss="modal" aria-label="Close"
              ref="closeModal">
              <span>Close</span>
            </button>
          </div>
          <!-- Modal Body -->
          <div class="modal__body modal__body--pad">
            <form class="disburse__confirmation" @submit.prevent="handleSingleDisbursement()" v-if="disburseNotFinished">
              <div class="disburse__confirmation__title text-center">
                You are about to send
                <span class>{{ payoutObj.wallet.currency }}{{ payoutObj.amount }}</span>
                to <br />
                <span>{{
                  beneficiaryAccountDetail.id === 0
                  ? accountNameInfo || payoutObj.accountName
                  : beneficiaryAccountDetail.accountName
                }}</span>
                for <br />
                {{ payoutObj.narration }}
              </div>
              <div class="disburse__confirmation__breakdown">
                <!--amount disbursed-->
                <div class="breakdown__item">
                  <div class="breakdown__item__name">Payment amount</div>
                  <div class="breakdown__item__result">
                    {{ payoutObj.wallet.currency }}
                    {{ payoutObj.amount }}
                  </div>
                </div>

                <!--funding source-->
                <div class="breakdown__item">
                  <div class="breakdown__item__name">Funding source</div>
                  <div class="breakdown__item__result">
                    {{ payoutObj.source }} -
                    {{ payoutObj.wallet.currency }} balance
                  </div>
                </div>

                <!--recipient-->
                <!--account name resolved, beneficiary name-->
                <div class="breakdown__item">
                  <div class="breakdown__item__name">Recipient</div>
                  <div class="breakdown__item__result">
                    {{
                      beneficiaryAccountDetail.id == 0
                      ? accountNameInfo || payoutObj.accountName
                      : beneficiaryAccountDetail.accountName
                    }}
                  </div>
                </div>

                <!--account-->
                <div class="breakdown__item">
                  <div class="breakdown__item__name">Account</div>
                  <div class="breakdown__item__result">
                    {{ payoutObj.accountNumber }}
                  </div>
                  <!--GTB -->
                </div>

                <div class="breakdown__item">
                  <div class="breakdown__item__name">Bank</div>
                  <div class="breakdown__item__result">
                    {{
                      banksListObj[payoutObj.accountBankCode]
                      ? banksListObj[payoutObj.accountBankCode].name
                      : ""
                    }}
                  </div>
                </div>

                <div class="breakdown__item" v-if="branchRequired">
                  <div class="breakdown__item__name">Branch</div>
                  <div class="breakdown__item__result">
                    {{
                      branchListObj[payoutObj.branchCode]
                      ? branchListObj[payoutObj.branchCode].toLowerCase()
                      : ""
                    }}
                  </div>
                </div>
              </div>

              <!--confirm disbursement-->
              <div class="disburse__confirmation__submit">
                <button class="btn btn--primary btn--block submit__paymentForm" type="submit">
                  CONFIRM PAYMENT
                </button>
              </div>
            </form>

            <div class="disburse__result text-center" v-if="disburseDone">
              <div v-if="disburseSuccessful">
                <!--success icon-->
                <div class="result-img">
                  <svg class="icon icon--custom-big" enable-background="new 0 0 50 50" version="1.1" viewBox="0 0 50 50"
                    xml:space="preserve" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="25" cy="25" r="25" fill="#25AE88"></circle>
                    <polyline points="38 15 22 33 12 25" fill="none" stroke="#fff" stroke-linecap="round"
                      stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2"></polyline>
                  </svg>
                </div>
                <p class="disburse__result__success success-text">
                  {{ disburseDoneMsg }}
                </p>
                <button class="btn btn--primary" @click="utilityMethods().triggerPageLoad()">
                  Make another transfer
                </button>
                <button class="btn btn--default" @click="utilityMethods().triggerRefresh()">
                  Check transfers status
                </button>
                <button class="btn btn--default" @click="utilityMethods().triggerCreateBeneficiary()" v-if="!exist"
                  data-toggle="modal" data-target="#createBeneficiaryModal">
                  Add receiver to beneficiary
                </button>
              </div>

              <div v-if="disburseFailed">
                <div class="result-img">
                  <svg enable-background="new 0 0 50 50" version="1.1" viewBox="0 0 50 50" xml:space="preserve"
                    xmlns="http://www.w3.org/2000/svg" class="icon icon--custom-big">
                    <circle cx="25" cy="25" r="25" fill="#D75A4A"></circle>
                    <polyline points="16 34 25 25 34 16" fill="none" stroke="#fff" stroke-linecap="round"
                      stroke-miterlimit="10" stroke-width="2"></polyline>
                    <polyline points="16 16 25 25 34 34" fill="none" stroke="#fff" stroke-linecap="round"
                      stroke-miterlimit="10" stroke-width="2"></polyline>
                  </svg>
                </div>
                <p v-for="error in disburseErrors" class="disburse__result__error error-text">
                  {{ error }}
                </p>
                <button data-dismiss="modal" aria-label="Close" class="btn btn--primary"
                  @click="utilityMethods().triggerPageLoad()">
                  Retry transfer
                </button>
                <button class="btn btn--default" @click="utilityMethods().triggerRefresh()">
                  See all transfers
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="schedulePaymentModal" tabindex="-1" role="dialog" aria-labelledby="schedulePaymentModal">
      <!-- Modal Dialog -->
      <div class="modal__dialog modal__dialog--xlg" role="document">
        <!-- Modal content -->
        <div class="modal__content">
          <div class="modal__header">
            <div class="modal__title">
              <span class="time-icon">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1"
                  id="Capa_1" x="0px" y="0px" width="512px" height="512px" viewBox="0 0 612 612"
                  style="enable-background: new 0 0 612 612" xml:space="preserve" class="icon--sm">
                  <g>
                    <g>
                      <g>
                        <path
                          d="M587.572,186.881c-32.266-75.225-87.096-129.934-162.949-162.285C386.711,8.427,346.992,0.168,305.497,0.168    c-41.488,0-80.914,8.181-118.784,24.428C111.488,56.861,56.415,111.535,24.092,186.881C7.895,224.629,0,264.176,0,305.664    c0,41.496,7.895,81.371,24.092,119.127c32.323,75.346,87.403,130.348,162.621,162.621c37.877,16.247,77.295,24.42,118.784,24.42    c41.489,0,81.214-8.259,119.12-24.42c75.853-32.352,130.683-87.403,162.956-162.621C603.819,386.914,612,347.16,612,305.664    C612,264.176,603.826,224.757,587.572,186.881z M538.724,440.853c-24.021,41.195-56.929,73.876-98.375,98.039    c-41.195,24.021-86.332,36.135-134.845,36.135c-36.47,0-71.27-7.024-104.4-21.415c-33.129-14.384-61.733-33.294-85.661-57.215    c-23.928-23.928-42.973-52.811-57.214-85.997c-14.199-33.065-21.08-68.258-21.08-104.735c0-48.52,11.921-93.428,35.807-134.509    c23.971-41.231,56.886-73.947,98.039-98.04c41.146-24.092,85.99-36.142,134.502-36.142c48.52,0,93.649,12.121,134.845,36.142    c41.446,24.164,74.283,56.879,98.375,98.039c24.092,41.153,36.135,85.99,36.135,134.509    C574.852,354.185,562.888,399.399,538.724,440.853z"
                          data-original="#000000" class="active-path" data-old_color="#576ae6" fill="#576ae6"></path>
                        <path
                          d="M324.906,302.988V129.659c0-10.372-9.037-18.738-19.41-18.738c-9.701,0-18.403,8.366-18.403,18.738v176.005    c0,0.336,0.671,1.678,0.671,2.678c-0.671,6.024,1.007,11.043,5.019,15.062l100.053,100.046c6.695,6.695,19.073,6.695,25.763,0    c7.694-7.695,7.188-18.86,0-26.099L324.906,302.988z"
                          data-original="#000000" class="active-path" data-old_color="#576ae6" fill="#576ae6"></path>
                      </g>
                    </g>
                  </g>
                </svg>
              </span>
              Schedule this
              <span>transfer</span>
            </div>
            <!-- Modal close button -->
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13">
                <path fill="#C0C6D8" fill-rule="nonzero"
                  d="M8.254 6.5l4.383-4.382A1.24 1.24 0 0 0 10.882.363L6.5 4.746 2.118.363A1.24 1.24 0 1 0 .363 2.118L4.746 6.5.363 10.882a1.24 1.24 0 0 0 1.755 1.755L6.5 8.254l4.382 4.383a1.24 1.24 0 1 0 1.755-1.755L8.254 6.5z">
                </path>
              </svg>
            </button>
          </div>
          <!-- Modal Body -->
          <div class="modal__body modal__body--pad">
            <div class="disburse__confirmation">
              <div class="disburse__confirmation__breakdown">
                <!--amount disbursed-->
                <div class="breakdown__item">
                  <div class="breakdown__item__name">Payment amount</div>
                  <div class="breakdown__item__result">$ 12,348,232</div>
                </div>

                <!--funding source-->
                <div class="breakdown__item">
                  <div class="breakdown__item__name">Funding source</div>
                  <div class="breakdown__item__result">Wallet (USD)</div>
                </div>

                <!--recipient-->
                <div class="breakdown__item">
                  <div class="breakdown__item__name">Recipient</div>
                  <div class="breakdown__item__result">Tammy Baker</div>
                </div>

                <!--account-->
                <div class="breakdown__item">
                  <div class="breakdown__item__name">Account</div>
                  <div class="breakdown__item__result">GTB (2080)</div>
                </div>
              </div>

              <div class="disbursement__schedule">
                <label for="disburseAmount" class="form__label--span form--left">Schedule
                  <span>transfer for</span>
                </label>
                <div class="form__item">
                  <div class="form--right">
                    <div class="select disburse__day-schedule">
                      <label class="sr-only" for="disburseDay">Select day</label>
                      <select name="disburse-day" id="disburseDay" class="select__input">
                        <option value="Day">Day</option>
                        <option value="Monday">Monday</option>
                        <option value="Tuesday">Tuesday</option>
                        <option value="Wednesday">Wednesday</option>
                        <option value="thursday">Thursday</option>
                        <option value="Friday">Friday</option>
                        <option value="Saturday">Saturday</option>
                      </select>
                      <div class="select__icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="6" height="10" viewBox="0 0 6 10">
                          <path fill-rule="evenodd"
                            d="M6.03 3.03L3.025.025.02 3.03h6.01zM5.88 7.071L2.975 9.975.07 7.07H5.88z"></path>
                        </svg>
                      </div>
                    </div>
                    <div class="select disburse__month-schedule">
                      <label class="sr-only" for="disburseMonth">Select Month</label>
                      <select name="disburse-year" id="disburseMonth" class="select__input">
                        <option value="Day">Month</option>
                        <option value="Monday">Monday</option>
                        <option value="Tuesday">Tuesday</option>
                        <option value="Wednesday">Wednesday</option>
                        <option value="thursday">Thursday</option>
                        <option value="Friday">Friday</option>
                        <option value="Saturday">Saturday</option>
                      </select>
                      <div class="select__icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="6" height="10" viewBox="0 0 6 10">
                          <path fill-rule="evenodd"
                            d="M6.03 3.03L3.025.025.02 3.03h6.01zM5.88 7.071L2.975 9.975.07 7.07H5.88z"></path>
                        </svg>
                      </div>
                    </div>
                    <div class="select disburse__year-schedule">
                      <label class="sr-only" for="disburseYear">Select Year</label>
                      <select name="disburse-month" id="disburseYear" class="select__input">
                        <option value="Day">Year</option>
                        <option value="Monday">Monday</option>
                        <option value="Tuesday">Tuesday</option>
                        <option value="Wednesday">Wednesday</option>
                        <option value="thursday">Thursday</option>
                        <option value="Friday">Friday</option>
                        <option value="Saturday">Saturday</option>
                      </select>
                      <div class="select__icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="6" height="10" viewBox="0 0 6 10">
                          <path fill-rule="evenodd"
                            d="M6.03 3.03L3.025.025.02 3.03h6.01zM5.88 7.071L2.975 9.975.07 7.07H5.88z"></path>
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>

                <!--schedule transfer-->
                <div class="form__item">
                  <label for="disburseAmount" class="form__label--span form--left">Repeat
                    <span>every</span>
                  </label>
                  <div class="form--right">
                    <div class="select disburse__month-schedule">
                      <select name="disburse__month-schedule" id="disburseScheduleMonth" class="select__input">
                        <option value="month">Month</option>
                        <option value="week">Week</option>
                        <option value="year">Year</option>
                      </select>
                      <div class="select__icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="6" height="10" viewBox="0 0 6 10">
                          <path fill-rule="evenodd"
                            d="M6.03 3.03L3.025.025.02 3.03h6.01zM5.88 7.071L2.975 9.975.07 7.07H5.88z"></path>
                        </svg>
                      </div>
                    </div>
                    <div class="form__input form__input--fake">On the</div>
                    <div class="select disburse__day-schedule">
                      <select name="disburse__day-schedule" id="disburseScheduleDay" class="select__input">
                        <option value="1st">1st</option>
                        <option value="2nd">2nd</option>
                        <option value="3rd">3rd</option>
                        <option value="4th">4th</option>
                      </select>
                      <div class="select__icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="6" height="10" viewBox="0 0 6 10">
                          <path fill-rule="evenodd"
                            d="M6.03 3.03L3.025.025.02 3.03h6.01zM5.88 7.071L2.975 9.975.07 7.07H5.88z"></path>
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!--confirm disbursement-->
              <div class="disburse__confirmation__submit">
                <button class="btn btn--primary btn--block">
                  SCHEDULE TRANSFER
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="two-factor-authentication" tabindex="-1" role="dialog"
      aria-labelledby="two-factor-authentication">
      <!-- Modal Dialog -->
      <div class="modal__dialog modal__dialog--xlg" role="document">
        <!-- Modal content -->
        <div class="modal__content">
          <div class="modal__header">
            <div class="modal__title">
              <span class="time-icon">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1"
                  id="Capa_1" x="0px" y="0px" width="512px" height="512px" viewBox="0 0 612 612"
                  style="enable-background:new 0 0 612 612;" xml:space="preserve" class="icon--sm">
                  <g>
                    <g>
                      <g>
                        <path
                          d="M587.572,186.881c-32.266-75.225-87.096-129.934-162.949-162.285C386.711,8.427,346.992,0.168,305.497,0.168    c-41.488,0-80.914,8.181-118.784,24.428C111.488,56.861,56.415,111.535,24.092,186.881C7.895,224.629,0,264.176,0,305.664    c0,41.496,7.895,81.371,24.092,119.127c32.323,75.346,87.403,130.348,162.621,162.621c37.877,16.247,77.295,24.42,118.784,24.42    c41.489,0,81.214-8.259,119.12-24.42c75.853-32.352,130.683-87.403,162.956-162.621C603.819,386.914,612,347.16,612,305.664    C612,264.176,603.826,224.757,587.572,186.881z M538.724,440.853c-24.021,41.195-56.929,73.876-98.375,98.039    c-41.195,24.021-86.332,36.135-134.845,36.135c-36.47,0-71.27-7.024-104.4-21.415c-33.129-14.384-61.733-33.294-85.661-57.215    c-23.928-23.928-42.973-52.811-57.214-85.997c-14.199-33.065-21.08-68.258-21.08-104.735c0-48.52,11.921-93.428,35.807-134.509    c23.971-41.231,56.886-73.947,98.039-98.04c41.146-24.092,85.99-36.142,134.502-36.142c48.52,0,93.649,12.121,134.845,36.142    c41.446,24.164,74.283,56.879,98.375,98.039c24.092,41.153,36.135,85.99,36.135,134.509    C574.852,354.185,562.888,399.399,538.724,440.853z"
                          data-original="#000000" class="active-path" data-old_color="#576ae6" fill="#576ae6"></path>
                        <path
                          d="M324.906,302.988V129.659c0-10.372-9.037-18.738-19.41-18.738c-9.701,0-18.403,8.366-18.403,18.738v176.005    c0,0.336,0.671,1.678,0.671,2.678c-0.671,6.024,1.007,11.043,5.019,15.062l100.053,100.046c6.695,6.695,19.073,6.695,25.763,0    c7.694-7.695,7.188-18.86,0-26.099L324.906,302.988z"
                          data-original="#000000" class="active-path" data-old_color="#576ae6" fill="#576ae6"></path>
                      </g>
                    </g>
                  </g>
                </svg>
              </span>
              Enter Two-Factor Authentication
            </div>
            <!-- Modal close button -->
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13">
                <path fill="#C0C6D8" fill-rule="nonzero"
                  d="M8.254 6.5l4.383-4.382A1.24 1.24 0 0 0 10.882.363L6.5 4.746 2.118.363A1.24 1.24 0 1 0 .363 2.118L4.746 6.5.363 10.882a1.24 1.24 0 0 0 1.755 1.755L6.5 8.254l4.382 4.383a1.24 1.24 0 1 0 1.755-1.755L8.254 6.5z">
                </path>
              </svg>
            </button>
          </div>
          <!-- Modal Body -->
          <div class="modal__body modal__body--pad">
            <div class>
              <form action class="form disburse-form" @submit.prevent="handleSingleDisbursement('submitOTP')">
                <div class="form__item">
                  <label for="disburseSource" class="form__label--span form--left">
                    Enter <span>OTP</span>
                  </label>
                  <div class="otp-input-group">
                    <span class="pre-otp">{{otpPrefix}}</span>
                    <span class="connector">-</span>
                    <input type="text" name="otp" v-model="otp" aria-required="true"
                        aria-invalid="false">
                  </div>
                </div>
                <div class="form__item disburse-form__submit">
                  <button type="submit" class="btn btn--primary btn--block">Process Payment</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>

    <modal-template v-if="showModal" @close="showModal = false">
      <div slot="header" class="display__inline-block">
        <div class="modal__title" v-if="fundPrompt">
          Heads up
          <span>{{ showUserName }}!</span>
        </div>
        <div class="modal__title" v-if="fundingFormSelected">
          Fund
          <span>Wallet</span>
        </div>
      </div>
      <div slot="action-button" class="modal-default-button display__inline-block" v-if="fundingFormSelected">
        <button class="btn btn--default">Back</button>
      </div>

      <div slot="body">
        <transition name="slide-fade">
          <div class="fund-wallet__prompt" v-if="fundPrompt">
            <div class="fund-wallet__prompt__text">
              <p>
                You currently have zero balance in your wallet. You need to fund
                your wallet in order to make transfers to your beneficiaries.
              </p>
              <p>Do you want to fund your wallet now?</p>
              <div class="fund-wallet__prompt__actions">
                <button class="btn btn--primary" @click="fundWalletMethods().showFundingForm()">
                  Yes, thanks!
                </button>
                <router-link :to="{ name: 'overview' }" class="btn btn--flat">No, I'll transfer later</router-link>
              </div>
            </div>
          </div>
        </transition>
        <transition name="slide-fade">
          <div class="fund-wallet__prompt--form" v-if="fundingFormSelected">
            <form action class="form">
              <!--funding source, never mind my classes says disburse - copy and paste ish-->
              <div class="form__item">
                <label for="fundingSource" class="form__label--span form--left">Add money
                  <span>from</span>
                </label>
                <div class="select form--right">
                  <select name="disburse-source" id="fundingSource" class="select__input">
                    <option value="Bank source">
                      Card, account or Bank (via Rave)
                    </option>
                    <option value="Card source">Linked Cards</option>
                    <option value="Card source">E-Bills</option>
                    <option value="Card source">Voucher</option>
                  </select>
                  <div class="select__icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="6" height="10" viewBox="0 0 6 10">
                      <path fill-rule="evenodd"
                        d="M6.03 3.03L3.025.025.02 3.03h6.01zM5.88 7.071L2.975 9.975.07 7.07H5.88z"></path>
                    </svg>
                  </div>
                </div>
              </div>

              <!--funding amount-->
              <div class="form__item">
                <label for="currencySelect" class="form__label--span form--left">
                  <span>Amount</span>
                </label>
                <div class="form--right">
                  <div class="select currency-select">
                    <select name="disburse-amount" id="currencySelect" class="select__input">
                      <option value="USD wallet">USD ($)</option>
                      <option value="USD wallet">KES (Sh)</option>
                      <option value="USD wallet">GHC (GH)</option>
                      <option value="USD wallet">NGN (#)</option>
                    </select>
                    <div class="select__icon">
                      <svg xmlns="http://www.w3.org/2000/svg" width="6" height="10" viewBox="0 0 6 10">
                        <path fill-rule="evenodd"
                          d="M6.03 3.03L3.025.025.02 3.03h6.01zM5.88 7.071L2.975 9.975.07 7.07H5.88z"></path>
                      </svg>
                    </div>
                  </div>
                  <div class="amount-input">
                    <input type="text" class="form__input" placeholder />
                  </div>
                </div>
              </div>

              <!--funding destination-->
              <div class="form__item">
                <label for="fundingDestination" class="form__label--span form--left">
                  <span>Destination</span>
                </label>
                <div class="select form--right">
                  <select name="disburse-source" id="fundingDestination" class="select__input">
                    <option value="USD wallet">
                      Wallet - USD ($328,000,000)
                    </option>
                    <option value="USD wallet">
                      Wallet - USD ($328,000,000)
                    </option>
                    <option value="USD wallet">
                      Wallet - USD ($328,000,000)
                    </option>
                    <option value="USD wallet">
                      Wallet - USD ($328,000,000)
                    </option>
                  </select>
                  <div class="select__icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="6" height="10" viewBox="0 0 6 10">
                      <path fill-rule="evenodd"
                        d="M6.03 3.03L3.025.025.02 3.03h6.01zM5.88 7.071L2.975 9.975.07 7.07H5.88z"></path>
                    </svg>
                  </div>
                </div>
              </div>

              <div class="form__item disburse-form__submit">
                <a class="btn btn--primary btn--block">ADD MONEY</a>
              </div>
            </form>
          </div>
        </transition>
      </div>
    </modal-template>
    <div class="modal fade" id="createBeneficiaryModal" tabindex="-1" role="dialog"
      aria-labelledby="createBeneficiaryModal">
      <!-- Modal Dialog -->
      <div class="modal__dialog modal__dialog--xlg" role="document">
        <!-- Modal content -->
        <div class="modal__content">
          <div class="modal__header">
            <div class="modal__title">
              <span class="time-icon">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1"
                  id="Capa_1" x="0px" y="0px" width="512px" height="512px" viewBox="0 0 612 612"
                  style="enable-background: new 0 0 612 612" xml:space="preserve" class="icon--sm">
                  <g>
                    <g>
                      <g>
                        <path
                          d="M587.572,186.881c-32.266-75.225-87.096-129.934-162.949-162.285C386.711,8.427,346.992,0.168,305.497,0.168    c-41.488,0-80.914,8.181-118.784,24.428C111.488,56.861,56.415,111.535,24.092,186.881C7.895,224.629,0,264.176,0,305.664    c0,41.496,7.895,81.371,24.092,119.127c32.323,75.346,87.403,130.348,162.621,162.621c37.877,16.247,77.295,24.42,118.784,24.42    c41.489,0,81.214-8.259,119.12-24.42c75.853-32.352,130.683-87.403,162.956-162.621C603.819,386.914,612,347.16,612,305.664    C612,264.176,603.826,224.757,587.572,186.881z M538.724,440.853c-24.021,41.195-56.929,73.876-98.375,98.039    c-41.195,24.021-86.332,36.135-134.845,36.135c-36.47,0-71.27-7.024-104.4-21.415c-33.129-14.384-61.733-33.294-85.661-57.215    c-23.928-23.928-42.973-52.811-57.214-85.997c-14.199-33.065-21.08-68.258-21.08-104.735c0-48.52,11.921-93.428,35.807-134.509    c23.971-41.231,56.886-73.947,98.039-98.04c41.146-24.092,85.99-36.142,134.502-36.142c48.52,0,93.649,12.121,134.845,36.142    c41.446,24.164,74.283,56.879,98.375,98.039c24.092,41.153,36.135,85.99,36.135,134.509    C574.852,354.185,562.888,399.399,538.724,440.853z"
                          data-original="#000000" class="active-path" data-old_color="#576ae6" fill="#576ae6"></path>
                        <path
                          d="M324.906,302.988V129.659c0-10.372-9.037-18.738-19.41-18.738c-9.701,0-18.403,8.366-18.403,18.738v176.005    c0,0.336,0.671,1.678,0.671,2.678c-0.671,6.024,1.007,11.043,5.019,15.062l100.053,100.046c6.695,6.695,19.073,6.695,25.763,0    c7.694-7.695,7.188-18.86,0-26.099L324.906,302.988z"
                          data-original="#000000" class="active-path" data-old_color="#576ae6" fill="#576ae6"></path>
                      </g>
                    </g>
                  </g>
                </svg>
              </span>
              Add a New Beneficiary
            </div>
            <!-- Modal close button -->
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13">
                <path fill="#C0C6D8" fill-rule="nonzero"
                  d="M8.254 6.5l4.383-4.382A1.24 1.24 0 0 0 10.882.363L6.5 4.746 2.118.363A1.24 1.24 0 1 0 .363 2.118L4.746 6.5.363 10.882a1.24 1.24 0 0 0 1.755 1.755L6.5 8.254l4.382 4.383a1.24 1.24 0 1 0 1.755-1.755L8.254 6.5z">
                </path>
              </svg>
            </button>
          </div>
          <!-- Modal Body -->
          <div class="modal__body modal__body--pad">
            <div class>
              <form action class="form disburse-form" @submit.prevent="handleCreateBeneficiaries()"
                v-if="addBeneficiaryNotFinished">
                <div class="form__item">
                  <label for="beneficiarySource" class="form__label--span form--left">
                    Beneficiary
                    <span>Name</span>
                  </label>
                  <div class="select form--right">
                    <input type="text" name="name" placeholder v-model="createObject.name" id="beneficiaryname"
                      class="form__input input" data-vv-id="1" aria-required="true" aria-invalid="false" />
                  </div>
                </div>
                <div class="form__item">
                  <label for="bank" class="form__label--span form--left">Select
                    <span>Bank</span>
                  </label>
                  <div class="select form--right">
                    <select disabled name="banks" id="bank" class="select__input" v-model="createObject.bankCode">
                      <option value disabled>Select Bank</option>
                      <option v-for="bank in filteredBankList" v-bind:value="[bank.shortCode, bank.value]">
                        {{ bank.name }}
                      </option>
                    </select>
                    <div class="select__icon">
                      <svg xmlns="http://www.w3.org/2000/svg" width="6" height="10" viewBox="0 0 6 10">
                        <path fill-rule="evenodd"
                          d="M6.03 3.03L3.025.025.02 3.03h6.01zM5.88 7.071L2.975 9.975.07 7.07H5.88z"></path>
                      </svg>
                    </div>
                  </div>
                </div>
                <div class="form__item" v-if="branchRequired">
                  <label for="bank" class="form__label--span form--left">Select
                    <span>Branch</span>
                  </label>
                  <div class="select form--right">
                    <select disabled name="branch" id="branch" class="select__input" v-model="createObject.branchCode">
                      <option value disabled>Select Branch</option>
                      <option v-for="(branch, code) in branchListObj" v-bind:value="code" v-bind:key="code">
                        {{ branch }}
                      </option>
                    </select>
                    <div class="select__icon">
                      <svg xmlns="http://www.w3.org/2000/svg" width="6" height="10" viewBox="0 0 6 10">
                        <path fill-rule="evenodd"
                          d="M6.03 3.03L3.025.025.02 3.03h6.01zM5.88 7.071L2.975 9.975.07 7.07H5.88z"></path>
                      </svg>
                    </div>
                  </div>
                </div>
                <div class="form__item">
                  <label for="beneficiarySource" class="form__label--span form--left">
                    Account
                    <span>Number</span>
                  </label>
                  <div class="select form--right">
                    <input disabled type="text" name="accountNumber" placeholder v-model="createObject.accountNumber"
                      id="accountNumber" class="form__input input" data-vv-id="1" aria-required="true"
                      aria-invalid="false" />
                  </div>
                </div>
                <div class="form__item">
                  <label for="beneficiarySource" class="form__label--span form--left">
                    <span>Email</span>
                  </label>
                  <div class="select form--right">
                    <input type="text" name="email" placeholder v-model="createObject.email" id="email"
                      class="form__input input" data-vv-id="1" aria-required="true" aria-invalid="false" />
                  </div>
                </div>
                <div class="form__item">
                  <label for="beneficiarySource" class="form__label--span form--left">
                    <span>Phone Number</span>
                  </label>
                  <div class="select form--right">
                    <input type="text" name="phone_number" placeholder v-model="createObject.phone_number"
                      id="phonenumber" class="form__input input" data-vv-id="1" aria-required="true"
                      aria-invalid="false" />
                  </div>
                </div>

                <div class="form__item">
                  <button type="submit" class="btn btn--primary btn--block beneficiary_submit">
                    Create Beneficiary
                  </button>
                </div>
              </form>

              <div class="disburse__result text-center" v-if="addBeneficiaryDone">
                <div v-if="addBeneficiarySuccessful">
                  <!--success icon-->
                  <div class="result-img">
                    <svg class="icon icon--custom-big" enable-background="new 0 0 50 50" version="1.1" viewBox="0 0 50 50"
                      xml:space="preserve" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="25" cy="25" r="25" fill="#25AE88"></circle>
                      <polyline points="38 15 22 33 12 25" fill="none" stroke="#fff" stroke-linecap="round"
                        stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2"></polyline>
                    </svg>
                  </div>
                  <p class="disburse__result__success success-text">
                    Beneficiary Created successfully!
                  </p>
                  <button class="btn btn--primary" @click="utilityMethods().triggerPageLoad()" data-dismis="modal"
                    aria-label="Close" data-toggle="modal" data-target="#createBeneficiaryModal">
                    Make Another Transfer
                  </button>
                  <button class="btn btn--default" @click="utilityMethods().triggerBeneficiaryPage()" data-dismis="modal"
                    aria-label="Close" data-toggle="modal" data-target="#createBeneficiaryModal">
                    See All Beneficiaries
                  </button>
                </div>

                <div v-if="addBeneficiaryFailed">
                  <div class="result-img">
                    <svg enable-background="new 0 0 50 50" version="1.1" viewBox="0 0 50 50" xml:space="preserve"
                      xmlns="http://www.w3.org/2000/svg" class="icon icon--custom-big">
                      <circle cx="25" cy="25" r="25" fill="#D75A4A"></circle>
                      <polyline points="16 34 25 25 34 16" fill="none" stroke="#fff" stroke-linecap="round"
                        stroke-miterlimit="10" stroke-width="2"></polyline>
                      <polyline points="16 16 25 25 34 34" fill="none" stroke="#fff" stroke-linecap="round"
                        stroke-miterlimit="10" stroke-width="2"></polyline>
                    </svg>
                  </div>
                  <p v-for="error in beneficiaryErrors" class="disburse__result__error error-text">
                    {{ error }}
                  </p>
                  <button class="btn btn--primary" @click="utilityMethods().triggerBeneficiaryRetry()">
                    Retry
                  </button>
                  <button class="btn btn--default" @click="utilityMethods().triggerPageLoad()" data-dismis="modal"
                    aria-label="Close" data-toggle="modal" data-target="#createBeneficiaryModal">
                    Make Another Transfer
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DisburseOptions from "@/components/partials/DisburseOptions";
import { makePayout } from "../../utils/wallet-transactions/transferService";
import {
  getWallets,
  getWalletById,
} from "../../utils/wallet-transactions/walletService";
import { getAllBanks } from "../../utils/helpers/utilitiesService";
import { getBankBranch } from "../../utils/helpers/utilitiesService";
import { resolveAccountName } from "../../utils/helpers/utilitiesService";
import {
  getBeneficiaries,
  createBeneficiaries,
} from "../../utils/wallet-transactions/beneficiariesService";
import ModalTemplate from "@/components/partials/ModalTemplate.vue";
import vSelect from "vue-select";
import Datepicker from 'vuejs-datepicker';

import countriesList from "../../utils/countriesList.json";
import moment from 'moment'

export default {
  beforeRouteEnter(to, from, next) {
    let permission = window.localStorage.getItem("permissions");
    permission = permission
      ? JSON.parse(window.localStorage.getItem("permissions"))
      : [];

    if (!permission.includes("wallet.disburse")) {
      next({
        name: "overview",
        query: { redirectFrom: to.fullPath },
      });
    } else next();
  },

  created() {
    localStorage.removeItem("tempBal");
    if (Object.keys(this.$route.params).length > 0) {
      this.handleSecondaryBalance(this.$route.params.id);
    }
    this.utilityMethods().handleBeneficiariesList(); // Fetches beneficiaries  when the component is created.
    this.utilityMethods().handleBanksFetch(); // Fetches banks  when the component is created.
    this.utilityMethods().handleCurrencyFetch(); // Fetches currency  when the component is created.
    this.fundWalletMethods().triggerModal(); //check if user has wallet with balances
  },

  data() {
    return {
      otp: "",
      otpPrefix: "",
      showModal: false,
      fundingFormSelected: false,
      fundPrompt: true,
      exist: false,
      bankSelected: "",
      walletOptions: [],
      walletCurrencyList: null,
      destinationOption: "saved_beneficiary",
      selectedBalance: {},
      SecondaryBalance: {},
      payoutObj: {
        source: "wallet",
        type: "single",
        sender: window.localStorage.getItem("merchantName"),
        amount: "",
        wallet: {
          password: "",
          currency: "",
          country: "",
        },
        narration: "",
        accountBankCode: "",
        accountNumber: "",
        accountName: "",
        branchCode: "",
        recipientAddress: "",
        custom_routingnumber: "",
        custom_recipientemail: "",
        custom_recipientphone: "",
        custom_swiftcode: "",
        custom_postalcode: "",
        custom_streetnumber: "",
        custom_streetname: "",
        custom_city: "",
        custom_senderemail: "",
        custom_senderphone: "",
        custom_sendercountry: "",
        custom_sendernationality: "",
        custom_senderaddress: "",
        custom_senderidtype: "",
        custom_senderidnumber: "",
        custom_senderdob: "",
        custom_senderoccupation: "",
        custom_sendersourceoffunds: "",
        custom_senderlocation: "",
        custom_question: "",
        custom_answer: "",
        custom_transfertype: "ACCOUNT",
      },
      createObject: {
        bankCode: "",
        accountNumber: "",
        name: "",
        phone_number: "",
        email: "",
        branchCode: "",
        currency: "",
      },
      addBeneficiaryDone: false,
      addBeneficiarySuccessful: false,
      addBeneficiaryFailed: false,
      addBeneficiaryNotFinished: true,
      beneficiaryErrors: [],
      beneficiaryAccountDetail: "",
      beneficiariesList: [],
      formInputValid: true,
      banksList: [],
      banksListObj: {},
      filteredBankList: [],
      filteredBeneficiary: [],
      branchListObj: {},
      branchRequired: false,
      disburseDoneMsg: "",
      accountNameError: "",
      disburseDone: false,
      disburseSuccessful: false,
      disburseFailed: false,
      disburseNotFinished: true,
      disburseErrors: [],
      accountNameInfo: null,
      currencyList: [],
      balanceAdded: 0,

      countriesList: countriesList,
    };
  },
  components: {
    "disburse-options": DisburseOptions,
    "modal-template": ModalTemplate,
    "v-select": vSelect,
    Datepicker
  },
  computed: {
    enableActions: {
      get() {
        return this.$store.state.enableActions;
      },
    },
    momentToday() {
      return moment().format('MMM DD, YYYY');
    },
    showUserName() {
      return this.$store.state.isUser.userFullName;
    },
    requireAccountName() {
      return ["KES", "GHS", "TZS", "UGX", "ZAR", "RWF"].includes(
        this.payoutObj.wallet.currency
      );
    },
    requireUSUKbeneficiary() {
      return ["NGNxxx", "USD", "EUR", "ZAR", "MWK"].includes(
        this.payoutObj.wallet.currency
      );
    },
    requiresafaricom() {
      return ["KES"].includes(this.payoutObj.wallet.currency);
    },
    benefNameRequired() {
      return ["XOF", "ZMW", "XAF"].includes(this.payoutObj.wallet.currency);
    },
    requireRecipientAddress() {
      return ["UGX", "USD"].includes(this.payoutObj.wallet.currency);
    },
    walletList() {
      let a = [];
      if (Object.keys(window.localStorage.getItem("walletList")).length > 0)
        a = JSON.parse(window.localStorage.getItem("walletList"));
      let index = {};
      let contains = false;
      if (
        Object.keys(this.SecondaryBalance).length > 0 &&
        this.balanceAdded < 2
      ) {
        Object.keys(a).forEach((response) => {
          index[a[response].currencyId] = response;
          if (a[response].currencyId === this.SecondaryBalance.id) {
            contains = true;
          }
        });
        if (contains == false) {
          a[
            Object.keys(
              JSON.parse(window.localStorage.getItem("walletList"))
            ).length
          ] = {
            country: this.SecondaryBalance.currency.countryTag,
            countryName: this.SecondaryBalance.currency.countryName,
            currencyBalance: this.SecondaryBalance.balance,
            currencyCode: this.SecondaryBalance.currency.shortCode,
            currencyId: this.SecondaryBalance.id,
            currencyUref: this.SecondaryBalance.uref,
            name: this.SecondaryBalance.name,
          };
          this.selectedBalance =
            a[
            Object.keys(
              JSON.parse(window.localStorage.getItem("walletList"))
            ).length
            ];
          window.localStorage.setItem(
            "tempBal",
            JSON.stringify(this.selectedBalance)
          );
          this.selectedSource(this.selectedBalance);
          this.balanceAdded += 1;
        } else {
          this.selectedBalance = a[index[this.$route.params.id]];
          this.selectedSource(a[index[this.$route.params.id]]);
          this.balanceAdded += 1;
        }
      } else if (window.localStorage.getItem("tempBal")) {
        // adding secondary wallets to the array
        // added 'tempBalance' and 'balanceAdded' to make sure you can change the wallets when you redirect from a secondary wallet,
        a[
          Object.keys(
            JSON.parse(window.localStorage.getItem("walletList"))
          ).length
        ] = JSON.parse(window.localStorage.getItem("tempBal"));
      }
      return a;
    },
  },
  watch: {
    'payoutObj.accountNumber'(newVal) {
      if (this.payoutObj.wallet.country === 'NG' && newVal.length >= 9) {
        this.utilityMethods().resolveAccountName();
      }
    },
    'payoutObj.accountBankCode'() {
      if ( this.payoutObj.wallet.country === 'NG' && this.payoutObj.accountNumber.length >= 9) {
        this.utilityMethods().resolveAccountName();
      }
    }
  },
  methods: {
    formatDOB(date) {
      this.payoutObj.custom_senderdob = moment(date).format().toString().split('T')[0].replace(/-/g, '/');
    },
    selectedBank(bankcode) {
      const b = this.banksListObj[bankcode];
      const self = this;
      self.branchRequired = false;
      if ( self.payoutObj.wallet.country === 'NG' && self.payoutObj.accountNumber.length >= 9) {
        this.utilityMethods().resolveAccountName();
      }
      getBankBranch(bankcode, b.country).then((resp) => {
        if (
          resp.status === 200 &&
          resp.data &&
          resp.data.data &&
          Object.values(resp.data.data).length
        ) {
          self.branchListObj = resp.data.data;
          self.branchRequired = true;
        }
      });
    },
    handleSecondaryBalance(id) {
      getWalletById(id)
        .then((resp) => {
          if (resp && resp.data) {
            this.SecondaryBalance = resp.data.data;
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    updateWallet(balance) {
      let new_list = [];
      let a = this.walletList;
      a.filter((index, wall) => {
        if (index.currencyId == this.selectedBalance.currencyId) {
          index.currencyBalance = index.currencyBalance - this.payoutObj.amount;
          new_list.push(index);
        } else {
          new_list.push(index);
        }
      });
      this.$store.commit("emptyPrimaryCurrencies");
      new_list.forEach((wallet) => {
        this.$store.commit("updatePrimaryWalletCurrencies", {
          currencyCode: wallet.currencyCode,
          currencyId: wallet.currencyId,
          currencyBalance: wallet.currencyBalance,
          currencyUref: wallet.currencyUref,
          country: wallet.country,
          countryName: wallet.countryName,
          name: wallet.name,
        });
      });
    },
    handleCreateBeneficiaries() {
      let submitBtn = document.getElementsByClassName("beneficiary_submit");
      submitBtn.disabled = true;
      submitBtn.innerHTML = "Processing...";
      let app = this;
      this.$Progress.start();
      this.createObject.currency = this.createObject.bankCode[0];
      createBeneficiaries(this.createObject)
        .then((response) => {
          if (response.status === 200) {
            this.addBeneficiaryNotFinished = false;
            this.addBeneficiaryDone = true;
            // if (response.data.status === "success") {
            this.addBeneficiarySuccessful = true;
            this.addBeneficiaryFailed = false;
            // }
            this.$Progress.finish();
          } else {
            this.addBeneficiaryNotFinished = false;
            this.addBeneficiaryDone = true;
            this.addBeneficiarySuccessful = false;
            this.addBeneficiaryFailed = true;
          }
        })
        .catch((err) => {
          this.$Progress.fail();
          console.error(err);
          this.beneficiaryErrors.push(err.response.data.message);
          this.addBeneficiaryDone = true;
          this.addBeneficiaryNotFinished = false;
          this.addBeneficiaryFailed = true;
          this.addBeneficiarySuccessful = false;
        });
    },
    selectedSource(wallet) {
      this.payoutObj.wallet.currency = wallet.currencyCode;
      this.payoutObj.wallet.country = wallet.country;
      this.banksListObj = {};
      this.filteredBankList = [];
      this.accountNameInfo = null;
      this.accountNameError = "";

      // this.banksList.filter((bank) => {
      //   if(bank.country.toLowerCase() === wallet.country.toLowerCase()) {
      //     this.banksListObj[bank.value] = { name: bank.name, country: bank.country };
      //     return true;
      //   }
      // });

      this.filteredBeneficiary = this.beneficiariesList.filter((benf) => {
        if (
          this.banksListObj[benf.bankCode] ||
          benf.id === 0 ||
          benf.enableForCurrency === wallet.currencyCode
        ) {
          return true;
        }
      });
      this.selectedBenf(this.beneficiaryAccountDetail);
    },
    selectedBenf(benf) {

      this.filteredBankList = [];
      this.banksListObj = {};
       if (benf !== null && benf.accountName === "New Account Details") {
         this.destinationOption = "new_account";
       } else {
        this.destinationOption = "saved_beneficiary";
       }

      if (benf.type === "pickup") {
        this.filteredBankList = this.banksList.filter((bank) => {
          if (
            bank.country.toLowerCase() ===
            this.payoutObj.wallet.country.toLowerCase() &&
            bank.pickup
          ) {
            this.banksListObj[bank.value] = {
              name: bank.name,
              country: bank.country,
              code: bank.value,
            };
            return true;
          }
        });
      } else if (benf.type === "new") {
        this.filteredBankList = this.banksList.filter((bank) => {
          if (
            bank.country.toLowerCase() ===
            this.payoutObj.wallet.country.toLowerCase()
          ) {
            this.banksListObj[bank.value] = {
              name: bank.name,
              country: bank.country,
              code: bank.value,
            };
            return true;
          }
        });
      }
    },
    verifyFields() {
      //validate all fields
      // if( this.payoutObj.accountName !== "") {
      //   this.accountNameInfo = this.payoutObj.accountName;
      // } else {
      //   this.accountNameInfo = ""
      // }
      this.$validator.validateAll().then((result) => {
        console.log("result", result)
        if (result) {
          if (this.beneficiaryAccountDetail.id >= 1) {
            this.payoutObj.accountBankCode =
              this.beneficiaryAccountDetail.bankCode;
            this.payoutObj.accountNumber =
              this.beneficiaryAccountDetail.accountNumber;
            // this.beneficiaryAccountDetail.branchCode =
          }

          if (this.beneficiaryAccountDetail.type === "pickup") {
            this.payoutObj.custom_transfertype = "CASHPICKUP";
            this.payoutObj.accountNumber = 1;
          } else {
            this.payoutObj.custom_transfertype = "ACCOUNT";
          }

          if (this.payoutObj.wallet.currency === 'NGN') {
            //trigger modal
            if( this.accountNameInfo) {
              $("#confirmPaymentModal").modal("show");
            }
          } else {
            $("#confirmPaymentModal").modal("show");
          }
        }
      });
    },
    //these methods have are called when a user needs to fund wallet before sending money
    fundWalletMethods() {
      let self = this;
      return {
        //check if user has a wallet balance, trigger funding form if true
        checkWalletBalance() {
          self.walletList.every((currency) => {
            return currency.currencyBalance <= 0;
          });
        },

        //  if  all returns true, trigger modal to fund
        triggerModal() {
          if (this.checkWalletBalance()) {
            self.showModal = true;
          }
        },

        //if user agrees to fund wallet, show form
        showFundingForm() {
          self.fundingFormSelected = true;
          self.fundPrompt = false;
        },
      };
    },

    utilityMethods() {
      let self = this;
      return {
        //fetch banks
        handleBanksFetch() {
          //this function calls the getWallets service.
          getAllBanks()
            .then((response) => {
              if (response.status === 200) {
                //reset list first
                self.banksList.length = 0;
                response.data.data.forEach((bank) => {
                  self.banksList.push({
                    name: bank.name,
                    country: bank.country,
                    value: bank.code,
                    pickup: bank.pickup,
                    shortCode: bank.shortCode,
                  });
                });
              }
            })

            //catch error from the getWallets API and do something about the errors
            .catch((error) => {
              self.$Progress.fail();
            });
        },

        handleCurrencyFetch() {
          self.$store.state.countryName.filter((countryName, key) => {
            self.currencyList.push({
              name: countryName,
              value: self.$store.state.countryTag[key],
            });
          });
        },

        resolveAccountName() {
          if (
            self.payoutObj.wallet.country === 'NG' &&
            self.beneficiaryAccountDetail.id === 0 &&
            self.payoutObj.accountNumber.length >= 9
          ) {
            self.accountNameInfo = "Checking ...";
            let app = this;
            let accountObject = {
              accountNumber: self.payoutObj.accountNumber,
              accountBankCode: self.payoutObj.accountBankCode,
              currency: self.payoutObj.wallet.currency,
            };
            resolveAccountName(accountObject)
              .then((response) => {
                if (response.status === 200) {
                  self.accountNameInfo = response.data.accountName;
                  self.accountNameError = "";
                } else {
                  self.accountNameInfo = null;
                  self.accountNameError = 'Failed to resolve account name';
                }
              })
              .catch((error) => {
                self.accountNameInfo = null;
                self.accountNameError = 'Failed to resolve account name';
              });
          } else {
          }
        },

        //get beneficiaries
        handleBeneficiariesList() {
          getBeneficiaries(200)
            .then((response) => {
              if (response.status === 200) {
                self.beneficiariesList.length = 0;
                self.beneficiariesList.push(
                  {
                    accountName: "New Account Details",
                    accountNumber: 0,
                    bankCode: 0,
                    id: 0,
                    type: "new",
                  },
                  {
                    accountName: "Cash Pickup",
                    accountNumber: 0,
                    bankCode: 0,
                    id: 0.1,
                    type: "pickup",
                    enableForCurrency: "USD",
                  }
                );

                response.data.data.forEach((b) => {
                  self.beneficiariesList.push({
                    accountName: b.alias,
                    accountNumber: b.accountNumber,
                    bankCode: b.bankCode,
                    id: b.id,
                    branchCode: b.meta ? JSON.parse(b.meta).branchCode : null,
                  });
                });
              }
            })
            .catch((error) => {
              console.error(error);
            });
        },

        //page load methods
        triggerRefresh() {
          self.$router.push("/transfers/all");
          location.reload();
        },
        triggerBeneficiaryPage() {
          self.$router.push("/beneficiaries");
          location.reload();
        },
        triggerBeneficiaryRetry() {
          self.beneficiaryErrors = [];
          self.showModal = false;
          self.addBeneficiaryNotFinished = true;
          self.addBeneficiaryDone = false;
          self.addBeneficiaryFailed = false;
          self.addBeneficiarySuccessful = false;
        },
        triggerCreateBeneficiary() {
          self.disburseErrors = [];
          self.showModal = false;
          self.disburseNotFinished = true;
          self.disburseFailed = false;
          self.disburseSuccessful = false;
          self.$refs.closeModal.click();
        },
        triggerPageLoad() {
          // self.$router.replace(this.$route.name);
          self.disburseErrors = [];
          self.showModal = false;
          self.disburseNotFinished = true;
          self.disburseFailed = false;
          self.disburseSuccessful = false;
          self.$refs.closeModal.click();
          self.addBeneficiaryDone = false;
          self.addBeneficiarySuccessful = false;
          self.addBeneficiaryFailed = false;
          self.addBeneficiaryNotFinished = true;
          self.beneficiaryErrors = [];
          self.createObject.phone_number = "";
          self.createObject.name = "";
          self.createObject.bankCode = "";
          self.createObject.accountNumber = "";
          self.createObject.email = "";
          self.createObject.branchCode = "";
        },
      };
    },


    prepareSingleDisburseData() {
      this.exist = false;
      if (!this.requireAccountName && !this.accountNameInfo) delete this.payoutObj.accountName;
      if (!this.requireRecipientAddress) delete this.payoutObj.recipientAddress;
      this.payoutObj.reference = `fe${Math.random()
        .toString()
        .slice(2, 10)}.${Math.random().toString().slice(2, 10)}`;
      Object.keys(this.beneficiariesList).forEach((response1) => {
        if (
          this.beneficiariesList[response1].accountNumber ===
          this.payoutObj.accountNumber
        ) {
          this.exist = true;
        }
      });
      if (
        this.payoutObj.branchCode === "" ||
        this.payoutObj.branchCode === null
      ) {
        this.payoutObj.branchCode = this.beneficiaryAccountDetail.branchCode;
      }
      if (
        this.payoutObj.accountName === "" ||
        this.payoutObj.accountName === null ||
        this.payoutObj.accountName === "."
      ) {
        this.payoutObj.accountName = this.beneficiaryAccountDetail.accountName;
      }
    },

    //send money methods
    handleSingleDisbursement(requestType = 'checkOTP') {
      console.log("requestType", requestType)
      if (this.accountNameInfo) {
        this.payoutObj.accountName = this.accountNameInfo
      }
      this.$Progress.start();

      //disable submit button on click
      let submitBtn = document.getElementsByClassName("submit__paymentForm");
      submitBtn.disabled = true;
      submitBtn.innerHTML = "Processing...";
      let freshRequest = true;
      let sendotp = false;
      let app = this;

      this.prepareSingleDisburseData();

      if (requestType == 'submitOTP') {
        freshRequest = false
        sendotp = this.otp
        this.otp = ""
      }

      let username = this.$cookies.get("userEmail");
      //this function calls the makePayout service.
      makePayout(this.payoutObj, username, freshRequest, sendotp)
        .then((response) => {
          //cache user details if getuser api call is successful
          if (requestType == 'submitOTP') {
            $("#confirmPaymentModal").modal("show");
            $("#two-factor-authentication").modal("hide");
          }

          if (response.status === 200) {
            app.disburseNotFinished = false;
            app.disburseDone = true;
            const checkRespCode = (response.data && response.data.code) ? response.data.code : response.data.data.code;
            switch (checkRespCode) {
              case "APPROVAL_REQUIRED":
                app.disburseDoneMsg = "Transfer saved for Approval!";
                break;
              case "REQUIRE_2FA": {
                $("#confirmPaymentModal").modal("hide");
                this.otpPrefix = response.data.otpPrefix ? response.data.otpPrefix : '----';
                $("#two-factor-authentication").modal("show");
                break;
              }
              case "TRANSFER_BLOCKED":
                app.disburseDoneMsg = response.data.data.msg;
                break;
              default:
                app.disburseDoneMsg = "Transfer initiated successfully!";
                break;
            }

            if (response.data.status === "success") {

              app.disburseSuccessful = true;
              app.disburseFailed = false;

              app.createObject.accountNumber = app.payoutObj.accountNumber;
              app.createObject.bankCode = [
                app.payoutObj.wallet.currency,
                app.payoutObj.accountBankCode,
              ];
              app.createObject.branchCode = app.payoutObj.branchCode;
              this.updateWallet(app.payoutObj.amount);
            }
            this.$Progress.finish();
          } else {
            app.disburseNotFinished = false;
            app.disburseDone = true;
            app.disburseSuccessful = false;
            app.disburseFailed = true;
          }
        })
        .catch((error) => {
          if (requestType == 'submitOTP') {
            $("#confirmPaymentModal").modal("show");
            $("#two-factor-authentication").modal("hide");
          }
          this.$Progress.fail();
          this.disburseErrors.push(error.response.data.message);
          app.disburseDone = true;
          app.disburseNotFinished = false;
          this.disburseFailed = true;
          this.disburseSuccessful = false;
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/disbursement/SendMoney.vue